import axiosClient from "./axiosClient";

const courseApi = {
  // -------------------------------------------------
  // -------------------------------------------------
  // -------------------------------------------------
  // Khóa lẻ
  // Lấy danh sách khóa lẻ
  getListCourse: async (params) => {
    const url = `/course/list`;
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  // Thêm khóa lẻ
  addCourse: async (data) => {
    const url = `/course`;
    const response = await axiosClient.post(url, data);
    return response;
  },
  // Xóa khóa lẻ
  deleteCourse: async (id) => {
    const url = `/course/${id}`;
    const response = await axiosClient.delete(url);
    return response;
  },
  // Thêm khóa lẻ
  updateCourse: async (data) => {
    const url = `/course`;
    const response = await axiosClient.put(url, data);
    return response;
  },
  // Xem 1 khóa lẻ
  viewACourse: async (param) => {
    const url = `/course`;
    const response = await axiosClient.get(url, { params: param });
    return response;
  },
  // -------------------------------------------------
  // -------------------------------------------------
  // -------------------------------------------------
  // Lấy danh sách combo
  getListCombo: async (params) => {
    const url = `/combo/list`;
    const response = await axiosClient.get(url, { params: params });
    return response;
  },
  // Thêm khóa lẻ
  addCombo: async (data) => {
    const url = `/combo`;
    const response = await axiosClient.post(url, data);
    return response;
  },
  // Xóa khóa lẻ
  deleteCombo: async (id) => {
    const url = `/combo/${id}`;
    const response = await axiosClient.delete(url);
    return response;
  },
  // Thêm khóa lẻ
  updateCombo: async (data) => {
    const url = `/combo`;
    const response = await axiosClient.put(url, data);
    return response;
  },
  viewACombo: async (param) => {
    const url = `/combo`;
    const response = await axiosClient.get(url, { params: param });
    return response;
  },
};

export default courseApi;
